const baseURL: string = "https://jjrentalapi.azurewebsites.net/api/";
const ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
const appId: string = "9"

export default baseURL;
export { ticketBaseURL, appId };